import MUImakeStyles from 'MUImakeStyles';
export default function makeStyles(styles, options) {
    return MUImakeStyles(styles, options);
}
